// extracted by mini-css-extract-plugin
export default {"itemContainer":"Item_itemContainer__SDMqw","itemInfo":"Item_itemInfo__FbKuq"};